// Function to set the app height CSS custom property
const setAppHeight = () => {
  document.documentElement.style.setProperty(
    "--app-height",
    `${window.innerHeight}px`
  );
};

// Initialize viewport height and set up listeners
export const initViewportHeight = () => {
  // Set initial height
  setAppHeight();

  // Handle resize events (including keyboard open/close)
  let resizeTimer: NodeJS.Timeout;
  const handleResize = () => {
    // Debounce resize events to avoid too many updates
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setAppHeight();
    }, 100);
  };

  // Listen for both resize and orientationchange
  window.addEventListener("resize", handleResize);
  window.addEventListener("orientationchange", () => {
    // Orientation change needs a longer delay
    setTimeout(setAppHeight, 300);
  });

  // Handle visual viewport API if available (better for mobile keyboards)
  if (window.visualViewport) {
    const updateViewport = () => {
      // Use the visual viewport height when keyboard is open
      const height = window.visualViewport!.height;
      document.documentElement.style.setProperty("--app-height", `${height}px`);
    };

    window.visualViewport.addEventListener("resize", updateViewport);
    window.visualViewport.addEventListener("scroll", updateViewport);
  }

  // Cleanup function
  return () => {
    window.removeEventListener("resize", handleResize);
    window.removeEventListener("orientationchange", setAppHeight);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", setAppHeight);
      window.visualViewport.removeEventListener("scroll", setAppHeight);
    }
    clearTimeout(resizeTimer);
  };
};

// Export the setAppHeight function for manual updates if needed
export { setAppHeight };
